import { render, staticRenderFns } from "./waitingDep.vue?vue&type=template&id=4e4cb3d7&scoped=true&"
import script from "./waitingDep.vue?vue&type=script&lang=js&"
export * from "./waitingDep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4cb3d7",
  null
  
)

export default component.exports